<template>
  <slot name="content">
    <div class="col-md-10 col-md-offset-1">
      <section :id="post.id" class="blog-landing">
        <article
          class="white-panel animated fadeInUp" style="position: relative;"
          v-for="image in post.images || []"
          :key="image.filename"
        >
          <img
            :src="`http://localhost:9000/story/${image.filename}`"
            alt="ALT"
          />
        </article>
      </section>
      <p>{{ post.content }}</p>
    </div>
  </slot>
</template>
<script>
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
};
</script>
<style scoped>
.blog-landing {
  position: relative;
  max-width: 100%;
  width: 100%;
}
img {
  width: 100%;
  max-width: 100%;
  height: auto;
}
.white-panel {
  position: absolute;
  background: white;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.3);
  padding: 10px;
}
.white-panel h1 {
  font-size: 1em;
}
.white-panel h1 a {
  color: #a92733;
}
.white-panel:hover {
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.5);
  margin-top: -5px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
</style>